import { Box, Flex, Text } from '@applatform/design-system';
import { useEnvironment } from 'context/EnvironmentContext/EnvironmentContext';
import {
  environmentSurface,
  environmentDot,
  environmentLabel,
} from 'theme/environmentColours';

interface EnvironmentChipProps {
  readonly currency?: string;
}

function EnvironmentChip({ currency = 'AUD' }: EnvironmentChipProps) {
  const { environment } = useEnvironment();

  return (
    <Flex
      role="group"
      aria-label="Environment"
      css={{
        alignItems: 'center',
        gap: '$2',
        mx: '$4',
        px: '$3',
        py: '$2',
        border: '1px solid',
        borderRadius: '$md',
        fontSize: '11.5px',
        fontWeight: '$bold',
        letterSpacing: '$wider',
        textTransform: 'uppercase',
        ...environmentSurface[environment],
      }}
    >
      <Box
        aria-hidden="true"
        css={{
          flexShrink: 0,
          width: '7px',
          height: '7px',
          borderRadius: '$full',
          backgroundColor: environmentDot[environment],
        }}
      />
      <Text css={{ fontWeight: 'inherit', letterSpacing: 'inherit' }}>
        {environmentLabel[environment]}
      </Text>
      <Text css={{ ml: 'auto', opacity: 0.7, fontWeight: 'inherit' }}>
        {currency}
      </Text>
    </Flex>
  );
}

export default EnvironmentChip;
